/** @format */

import React, { useEffect, useRef } from 'react';
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from '@/components/ui/input-otp';
import { Button } from '@/components/ui/button';
import { Formik, ErrorMessage } from 'formik';
import { useOtpVerify } from './hook';
import { cn } from '@/lib';
import { Loader2 } from 'lucide-react';

const StepOtp = ({ isCuriobit, onNext, onSuccess, state }: any) => {
  const { initialValues, otpValidationSchema, loading, handleSubmit } =
    useOtpVerify({ state, onNext, onSuccess });
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={otpValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, handleBlur, handleSubmit }) => {
        return (
          <div className='flex flex-col gap-6 px-6 pb-6'>
            <div>
              <p className='text-center  text-base font-bold'>
                Enter the OTP send to your phone number
              </p>
              <p className='text-center text-xs font-semibold text-zinc-500'>
                If you don’t have an account yet, we’ll create one for you.
              </p>
            </div>
            <div className='flex flex-col justify-center'>
              <InputOTP
                value={values?.code}
                onBlur={handleBlur}
                onChange={(text: any) => setFieldValue('code', text)}
                containerClassName='gap-6 flex justify-between'
                maxLength={6}
                ref={inputRef}
              >
                <InputOTPGroup>
                  <InputOTPSlot index={0} />
                </InputOTPGroup>
                <InputOTPGroup>
                  <InputOTPSlot index={1} />
                </InputOTPGroup>
                <InputOTPGroup>
                  <InputOTPSlot index={2} />
                </InputOTPGroup>
                <InputOTPGroup>
                  <InputOTPSlot index={3} />
                </InputOTPGroup>
                <InputOTPGroup>
                  <InputOTPSlot index={4} />
                </InputOTPGroup>
                <InputOTPGroup>
                  <InputOTPSlot index={5} />
                </InputOTPGroup>
              </InputOTP>
              <ErrorMessage
                component='p'
                className='pt-1 text-xs text-red-600'
                name='code'
              />
            </div>
            <Button
              className={cn('w-full rounded-lg p-5', isCuriobit ? "text-black bg-gradient-to-r from-yellow-400 via-amber-500 to-orange-500 " : "bg-primary text-white")}
              onClick={() => {
                if (!loading) {
                  handleSubmit()
                }
              }}
              disabled={loading}
              type='submit'
            >
              {loading ? <Loader2 className='animate-spin' /> : 'Continue'}
            </Button>
          </div>
        );
      }}
    </Formik>
  );
};

export default StepOtp;
